import { ReactElement, useEffect, useState } from 'react';
import classnames from 'classnames/bind';
import styles from './barChart.module.scss';

const cx = classnames.bind(styles);

export interface IBarChartData {
  title: string | ReactElement;
  value: number;
  emphasized?: boolean;
  interactionTrigger?: INTERACTION_TRIGGER;
}

const MIN_HEIGHT = 20;

const Bar = ({ title, value, emphasized, interactionTrigger }: IBarChartData) => {
  const [count, setCount] = useState(MIN_HEIGHT);

  useEffect(() => {
    let timeout: NodeJS.Timeout | null = null;
    if (interactionTrigger)
      timeout = setTimeout(() => {
        setCount(MIN_HEIGHT + value * 32);
      }, 600);
    else setCount(MIN_HEIGHT);

    return () => {
      timeout && clearTimeout(timeout);
    };
  }, [interactionTrigger, value]);

  return (
    <div className={cx('bar', { emphasized: emphasized })}>
      <span className={cx('title')}>{title}</span>
      <span
        className={cx('value')}
        style={{ width: count, transition: interactionTrigger ? 'all .7s ease-in-out' : '' }}
      />
    </div>
  );
};

type INTERACTION_TRIGGER = true | false;

interface BarChart {
  data?: Array<IBarChartData>;
  interactionTrigger?: INTERACTION_TRIGGER;
}

const BarChart = ({ data, interactionTrigger }: BarChart) => {
  const list = data?.map(({ title, value, emphasized }, index) => {
    return (
      <Bar
        key={index}
        title={title ? title : ''}
        value={value ? (value > 100 ? 100 : value < 0 ? 0 : value) : 0}
        emphasized={emphasized}
        interactionTrigger={interactionTrigger}
      />
    );
  });

  return <>{list}</>;
};

export default BarChart;
